<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
// 这个组件现在只作为路由容器
</script>

<style scoped>
#app {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eaeaea;
}
header h1 {
  color: #2c3e50;
  font-size: 1.8rem;
  margin: 0;
}
.language-switcher {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}
.language-switcher button {
  padding: 8px 15px;
  border: 1px solid #3498db;
  background: white;
  color: #3498db;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}
.language-switcher button:hover {
  background: #f8f9fa;
}
.language-switcher button.active {
  background: #3498db;
  color: white;
  border-color: #2980b9;
}
main {
  flex: 1;
}
footer {
  margin-top: 40px;
  padding-top: 15px;
  text-align: center;
  color: #7f8c8d;
  font-size: 0.9rem;
  border-top: 1px solid #eaeaea;
}

/* 移动端适配 */
@media (max-width: 768px) {
  #app {
    padding: 15px;
  }
  header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  header h1 {
    font-size: 1.5rem;
  }
  .language-switcher {
    width: 100%;
    justify-content: center;
  }
  .language-switcher button {
    padding: 6px 12px;
    font-size: 0.85rem;
  }
}
@media (max-width: 480px) {
  #app {
    padding: 10px;
  }
  header h1 {
    font-size: 1.3rem;
  }
}
</style>